// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountBusinessProfile --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  OpenapiAccountBusinessProfileIndustryEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAddressFragment} from './stripeAddressFragment';

import type {StripeAddressFragmentData} from './stripeAddressFragment';

const doc = gql`
  fragment StripeAccountBusinessProfileFragment on OpenapiAccountBusinessProfile {
    industry
    mcc
    name
    privacy_policy_url
    product_description
    refund_policy_url
    support_address {
      ...StripeAddressFragment
    }
    support_email
    support_phone
    support_url
    terms_of_service_url
    url
  }

  ${stripeAddressFragment}
`;

export const stripeAccountBusinessProfileFragment: StripeAccountBusinessProfileFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountBusinessProfileFragmentData = {
  readonly __typename: 'OpenapiAccountBusinessProfile';
  readonly industry: OpenapiAccountBusinessProfileIndustryEnum | null;
  readonly mcc: string | null;
  readonly name: string | null;
  readonly privacy_policy_url: string | null;
  readonly product_description: string | null;
  readonly refund_policy_url: string | null;
  readonly support_email: string | null;
  readonly support_phone: string | null;
  readonly support_url: string | null;
  readonly terms_of_service_url: string | null;
  readonly url: string | null;
  readonly support_address: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAddress'},
    [StripeAddressFragmentData]
  > | null;
};

export type StripeAccountBusinessProfileFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountBusinessProfileFragmentPermissions = {
  ...stripeAddressFragment.permissions,
} as const;

doc.permissions = stripeAccountBusinessProfileFragmentPermissions;

export type StripeAccountBusinessProfileFragmentPermissions = V1PermissionToken<
  typeof stripeAccountBusinessProfileFragmentPermissions
>;

export type StripeAccountBusinessProfileFragmentDocument = GraphQlDocument<
  StripeAccountBusinessProfileFragmentData,
  StripeAccountBusinessProfileFragmentVariables,
  StripeAccountBusinessProfileFragmentPermissions
>;
